var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"public-app",attrs:{"id":"app"}},[_c('v-main',{staticStyle:{"background-color":"white"}},[_c('router-view'),_c('fin-cookie-declaration')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }